// extracted by mini-css-extract-plugin
export var arrows = "_96-6";
export var decrementer = "_96-a";
export var disabled = "_96-4";
export var error = "_96-1";
export var hiddenText = "_96-b";
export var incrementer = "_96-9";
export var input = "_96-8";
export var inputWrapper = "_96-0";
export var leadingIcon = "_96-c";
export var readonly = "_96-3";
export var regular = "_96-7";
export var small = "_96-5";
export var warning = "_96-2";